import { render, staticRenderFns } from "./OrdersController.vue?vue&type=template&id=441de7d6&"
import script from "./OrdersController.vue?vue&type=script&lang=js&"
export * from "./OrdersController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports